import $ from 'jquery';
import AOS from 'aos';

import {focusHash, bindInPageLinks} from '../vendor/theme-scripts/theme-a11y';
import {load} from '../vendor/theme-scripts/theme-sections';
import loadScript from '../util/loader';
import wrap from '../util/wrap';

document.addEventListener('DOMContentLoaded', function () {
  // Load all registered sections on the page.
  load('*');

  // Animate on scroll
  if (window.theme.settings.animate_scroll) {
    AOS.init({once: true});
    document.body.classList.add('aos-initialized');
    document.body.classList.add('theme-animate-scroll');
  }

  // Animate on hover
  if (window.theme.settings.animate_hover) {
    document.body.classList.add('theme-animate-hover');
  }

  // When images load, clear the background color
  document.addEventListener('lazyloaded', function (event) {
    const lazyImage = event.target.parentNode;
    if (lazyImage.classList.contains('lazy-image')) {
      lazyImage.style.backgroundImage = 'none';
    }
  });

  // Target tables to make them scrollable
  const tableSelectors = '.rte table';
  const tables = document.querySelectorAll(tableSelectors);
  tables.forEach((table) => {
    wrap(table, 'rte__table-wrapper');
  });

  // Target iframes to make them responsive
  const iframeSelectors = '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
  const frames = document.querySelectorAll(iframeSelectors);
  frames.forEach((frame) => {
    wrap(frame, 'rte__video-wrapper');
  });

  document.addEventListener('mousedown', () => {
    document.body.classList.remove('focus-enabled');
  });
  document.addEventListener('keyup', (event) => {
    if (event.keyCode === 9) {
      document.body.classList.add('focus-enabled');
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (window.navigator.cookieEnabled) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $(`[data-slick-slider]`).each(function(){
    const $slider = $(this);
    if( $slider.hasClass('slick-slider') ) {
      return;
    }
    $slider.slick();

    if( typeof(AOS) !== 'undefined' ) {
      AOS.refresh();
    }
  });

  // Common a11y fixes
  focusHash();
  bindInPageLinks();

  let hasNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
  if (!hasNativeSmoothScroll) {
    loadScript({url: window.theme.assets.smoothscroll});
  }
});
